import * as COMPONENT from '@Components';
import '@Styles/home.css';

const Home = () => {
  return (
    <div className='home'>
      <COMPONENT.HomeHero />
      <COMPONENT.HomePartners />
      <COMPONENT.HomePromotion />
      <COMPONENT.HomeProducts />
      <COMPONENT.HomeTestimonials />
    </div>
  );
};

export default Home;
